
import barba from '@barba/core';
//import anime from 'animejs';

export default class{

	constructor(){
        barba.hooks.beforeOnce((data) => {
            this.init()
        })
        barba.hooks.enter((data) => {
            this.init()
        });
    }
    init (){

        const height = window.innerHeight;
        document.documentElement.style.setProperty( '--vh', height/100 + 'px');

        const lowerHeadingTit = document.querySelector(".c-lower__heading--primary .c-section__tit--primary")
        if(lowerHeadingTit){
            setTimeout(() => {
                lowerHeadingTit.classList.add('visible');
            }, 750);
        }

        const verticalTitles = document.querySelectorAll('.c-section__vertical--tit--primary');
        verticalTitles.forEach((verticalTit) => {
            const height = verticalTit.clientHeight;
            const newHeight = height + 5;
            verticalTit.style.height = `${newHeight}px`;
        });
    }
}